import { Link } from "react-router-dom";
import { Sparkles, Globe } from "lucide-react";
import { SidebarTrigger } from "@/components/ui/sidebar";
import { Button } from "@/components/ui/button";
import { GlobalSearch } from "./GlobalSearch";
import { WorkspaceSwitcher } from "./WorkspaceSwitcher";
import { NotificationsPopover } from "./NotificationsPopover";
import { ThemeToggle } from "./ThemeToggle";
import { ProfileMenu } from "./ProfileMenu";
import { usePilotEnrollment } from "@/hooks/usePilotEnrollment";

export function AppHeader() {
  const { isPilotOnlyAssessor } = usePilotEnrollment();

  return (
    <header className="header-glass sticky top-0 z-40 h-14 flex items-center px-3 sm:px-5 gap-2 sm:gap-3">
      <SidebarTrigger className="lg:hidden" />

      {/* Mobile-only brand lockup */}
      <Link to="/" className="lg:hidden flex flex-col leading-tight min-w-0">
        <span className="text-sm font-bold tracking-tight text-foreground truncate">
          SeniorHub
        </span>
        <span className="text-[9px] uppercase tracking-[0.14em] text-muted-foreground truncate">
          Powered by SAFE Tracker AI
        </span>
      </Link>

      <div className="flex-1 flex items-center justify-end lg:justify-start gap-2 min-w-0">
        <div className="hidden lg:flex items-center gap-2">
          <GlobalSearch />
          <WorkspaceSwitcher />
        </div>
      </div>

      <div className="flex items-center gap-1 sm:gap-1.5">
        <div className="lg:hidden">
          <GlobalSearch />
        </div>
        <Button
          asChild
          variant="ghost"
          size="sm"
          className="h-9 px-3 rounded-full gap-2 text-sm font-medium text-muted-foreground hover:text-foreground"
        >
          <Link to="/welcome" aria-label="View public website">
            <Globe className="h-4 w-4" />
            <span className="hidden sm:inline">View Website</span>
          </Link>
        </Button>
        {!isPilotOnlyAssessor && (
          <Button
            asChild
            variant="ghost"
            className="h-9 px-3 rounded-full gap-2 text-sm font-medium gradient-icon-ai text-white hover:opacity-90"
            style={{ width: "auto", borderRadius: 9999 }}
          >
            <Link to="/ai-insights" aria-label="AI Assistant">
              <Sparkles className="h-4 w-4" />
              <span className="hidden sm:inline">AI Assistant</span>
            </Link>
          </Button>
        )}
        <NotificationsPopover />
        <ThemeToggle />
        <ProfileMenu />
      </div>
    </header>
  );
}
